export default () => window.scrollTo(0, 0)


// WEBPACK FOOTER //
// ./src/functions/scrollToTop.js